import { useTranslation } from 'libs/i18n'

export const useSortingFilters = () => {
	const { t } = useTranslation()

	return {
		id: 'ordering',
		label: t('Sort by'),
		placeholder: t('Default'),
		options: [
			{
				value: 'name',
				label: `${t('Name')} asc`
			},
			{
				value: '-name',
				label: `${t('Name')} desc`
			},
			{
				value: 'email',
				label: `${t('Email')} asc`
			},
			{
				value: '-email',
				label: `${t('Email')} desc`
			}
		]
	}
}
